import { arrayOf, bool, number, shape, string } from "prop-types";
import { useMemo } from "react";

import DomesticTourismForm, {
  DOMESTIC_TOURISM_FORM_VARIANTS,
} from "web/Pages/Tourism/DomesticTourismForm";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import Fieldset from "../Shared/Fieldset";
import ActiveFiltersComponent from "./ActiveFilters";
import Map from "./Map";
import Reset from "./Reset";
import classes from "./filters.scss";

const Filters = ({
  filters,
  prices,
  facetsHidden,
  isAnixeTourism,
  withShiftedActiveFilters,
  ids,
}) => {
  const filtersCodes = useMemo(() => {
    return isArrayHasItems(filters)
      ? filters.map((filter) => filter.attribute_code)
      : [];
  }, [filters]);

  const children =
    filters?.map((filter) => (
      <Fieldset
        key={filter.attribute_code}
        title={filter.attribute_label}
        code={filter.attribute_code}
        type={filter.input_type}
        options={filter.attribute_options}
      />
    )) || [];
  children.splice(
    withShiftedActiveFilters ? 1 : 0,
    0,
    <ActiveFiltersComponent facetsHidden={facetsHidden} key="active-filters" />
  );

  return (
    <>
      {isAnixeTourism && (
        <DomesticTourismForm
          variant={DOMESTIC_TOURISM_FORM_VARIANTS.LISTING}
          fromFilters
        />
      )}

      {isArrayHasItems(filters) && (
        <div className={classes.marginTop}>
          {isAnixeTourism && <Map ids={ids} prices={prices} />}
          {children}
          <Reset codes={filtersCodes} facetsHidden={facetsHidden} />
        </div>
      )}
    </>
  );
};

Filters.propTypes = {
  filters: arrayOf(
    shape({
      attribute_label: string,
      attribute_type: string,
      values: shape({}),
    })
  ).isRequired,
  isAnixeTourism: bool,
  facetsHidden: arrayOf(string),
  withShiftedActiveFilters: bool,
  ids: arrayOf(number),
  prices: shape({}),
};

Filters.defaultProps = {
  isAnixeTourism: false,
  facetsHidden: [],
  withShiftedActiveFilters: false,
  prices: null,
};

export default Filters;
